// @flow
import { WritesonicActionTypes } from './constants';

type WritesonicAction = { type: string, payload: {} | string };

// common success
export const writesonicApiResponseSuccess = (actionType: string, data: any): WritesonicAction => ({
    type: WritesonicActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const writesonicApiResponseError = (actionType: string, error: string): WritesonicAction => ({
    type: WritesonicActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getIdeas = (params: any): WritesonicAction => ({
    type: WritesonicActionTypes.GET_IDEAS,
    payload: params
})

export const getIntro = (params: any): WritesonicAction => ({
    type: WritesonicActionTypes.GET_INTRO,
    payload: params
})

export const getOutlines = (params: any): WritesonicAction => ({
    type: WritesonicActionTypes.GET_OUTLINES,
    payload: params
})

export const writeArticle = (params: any): WritesonicAction => ({
    type: WritesonicActionTypes.WRITE_ARTICLE,
    payload: params
})

export const expandText = (params: any): WritesonicAction => ({
    type: WritesonicActionTypes.EXPAND_TEXT,
    payload: params
})

export const instantWriter = (params: any): WritesonicAction => ({
    type: WritesonicActionTypes.INSTANT_WRITER,
    payload: params
})

export const writeParagraph = (params: any): WritesonicAction => ({
    type: WritesonicActionTypes.WRITE_PARAGRAPH,
    payload: params
})

export const generateImage = (params: any): WritesonicAction => ({
    type: WritesonicActionTypes.GENERATE_IMAGE,
    payload: params
})

export const resetWritesonics = (): WritesonicAction => ({
    type: WritesonicActionTypes.RESET,
    payload: {},
});

